// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { withRouter } from 'react-router-dom';
import { sendTags } from 'utils/tagManagerUtils';

type Props = {
  onSetOverlay?: (overlay: boolean) => void,
  mobile?: boolean,
  history: any,
  onCloseMenu?: Function,
  clubName: string,
};

type ComponentState = {
  focused: boolean,
  value: string
};

class Search extends PureComponent<Props, ComponentState> {
  _node: any;
  static defaultProps = {
    mobile: false
  };
  state: ComponentState = {
    focused: false,
    value: '',
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick);
  }

  setFocused(focused: boolean) {
    this.setState({ focused });
    if (this.props.onSetOverlay) this.props.onSetOverlay(focused);
  }

  onFocus = () => {
    this.setFocused(true);
  };

  handleClick = (e: MouseEvent) => {
    if (!this._node.contains(e.target)) this.setFocused(false);
  };

  handleSubmit = (e: Event) => {
    const { clubName } = this.props;
    e.preventDefault();
    sendTags('recherche_classique','recherche', `/recherche?s=${this.state.value}`, clubName);
    this.props.history.replace(`/recherche?s=${this.state.value}`);
    this.setFocused(false);
    this.setState({value: ''});
    if (this.props.onCloseMenu) {
      this.props.onCloseMenu();
    }
  };

  handleChange = (e: Event) => {
    if (e.target instanceof HTMLInputElement) {
      this.setState({value: e.target.value});
    }
  };

  _onKeyUp = (event: any) => {
    if (event.keyCode === 13) {
      event.target.blur();
    }
  };


  render() {
    const { mobile } = this.props;
    const { focused } = this.state;
    let formLabel;

    const classNamesInput = dynamicClassName('input input--search input--expand');
    focused && classNamesInput.add('is-open has-overlay');

    if (mobile) {
      formLabel = "form_recherche_club_mobile";
    } else {
      formLabel = "form_recherche_club";
    }

    return (
      <form ref={node => (this._node = node)} onSubmit={this.handleSubmit}>
        <div className={classNamesInput.build()} data-overlay="false">
          <input
            type="search"
            id={formLabel}
            title="Effectuer une recherche sur le site"
            tabIndex={0}
            placeholder="Rechercher"
            onFocus={this.onFocus}
            onKeyUp={this._onKeyUp}
            value={this.state.value}
            onChange={this.handleChange}
            aria-label={'Effectuer une recherche sur le site'}
             />
        </div>
      </form>
    );
  }
}

export default withRouter(Search);
